export const opcoesPercentualSaldo = [
  { value: '0.1', label: '0,1%' },
  { value: '0.2', label: '0,2%' },
  { value: '0.3', label: '0,3%' },
  { value: '0.4', label: '0,4%' },
  { value: '0.5', label: '0,5%' },
  { value: '0.6', label: '0,6%' },
  { value: '0.7', label: '0,7%' },
  { value: '0.8', label: '0,8%' },
  { value: '0.9', label: '0,9%' },
  { value: '1.0', label: '1,0%' },
];
